<script lang="ts">
  import { fade } from "svelte/transition";
  import { twMerge } from "tailwind-merge";

  export let size: string;
  export let radius: string = "rounded";
  export let additionalClassNames: string = "";
</script>

<div
  class={twMerge("animate-pulse bg-black/10 dark:bg-white/10", size, radius, additionalClassNames)}
  in:fade={{ duration: 100 }}
/>
